import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./receipt_header_image_position.js";
//#region src/receipt_header_image_position_helper.ts
var receipt_header_image_position_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(position) {
	switch (position) {
		case "above": return "Above header text";
		case "below": return "Below header text";
	}
}
//#endregion
export { name, receipt_header_image_position_helper_exports };

//# sourceMappingURL=receipt_header_image_position_helper.js.map